const STATUS_CLASSES: Record<string, string> = {
    draft: "bg-gray-100 text-gray-700 border-gray-500",
    pending: "bg-amber-100 text-amber-700 border-amber-500",
    checking: "bg-blue-100 text-blue-700 border-blue-500",
    rating: "bg-violet-100 text-violet-700 border-violet-500",
    approved: "bg-green-100 text-green-700 border-green-500",
    released: "bg-sky-100 text-sky-700 border-sky-500",
    amend: "bg-orange-100 text-orange-700 border-orange-500",
    booked: "bg-emerald-100 text-emerald-700 border-emerald-500",
    closed: "bg-slate-100 text-slate-600 border-slate-500",
    rejected: "bg-red-100 text-red-700 border-red-500",
};

export const getStatusClasses = (status: string): string => {
    return (
        STATUS_CLASSES[status.toLowerCase()] ??
        "bg-gray-100 text-gray-700 border-gray-500"
    );
};